import PhoneForwardedOutlined from '@mui/icons-material/PhoneForwardedOutlined'
import PhoneCallbackOutlined from '@mui/icons-material/PhoneCallbackOutlined'
import { Box, Grid, IconButton, Typography } from '@mui/material'
import { PhoneCallerInfo } from 'hooks/useHardwareAgent/CallerId/useCallerIdHubReducer'
import { Trans, useTranslation } from 'react-i18next'
import { Delete } from '@mui/icons-material'
import { useScreenSize } from 'hooks/useScreenSize/useScreenSize'
import ConfirmDialog from 'components/Dialog/ConfirmDialog'
import { useState } from 'react'

function IOType({ io }: { io: 'I' | 'O' }) {
    const { t } = useTranslation()
    return (
        <Box display={'flex'}>
            {io === 'I' ? (
                <>
                    <PhoneCallbackOutlined color="info" />
                    <Typography>{t('customers.label.incoming')}</Typography>
                </>
            ) : io === 'O' ? (
                <>
                    <PhoneForwardedOutlined color="primary" />
                    <Typography>{t('customers.label.outgoing')}</Typography>
                </>
            ) : (
                <>{/* Don't display anything when io is not specified. */}</>
            )}
        </Box>
    )
}

function EachPhoneInfo({
    phoneCallerInfo,
    onClick,
    onRemove,
}: {
    phoneCallerInfo: PhoneCallerInfo
    onClick: () => void
    onRemove: () => void
}) {
    const { t } = useTranslation()
    const { isMobile } = useScreenSize()
    const [openConfirmPopup, setOpenConfirmPopup] = useState<boolean>(false)
    return (
        <Box
            display="flex"
            sx={{
                py: 2,
                borderBottom: (theme) =>
                    '1px solid' + theme.palette.default.main,
            }}
        >
            <Grid container spacing={2} justifyContent={'end'}>
                <Grid
                    item
                    container
                    spacing={isMobile ? 2 : 4}
                    onClick={onClick}
                    sx={{
                        cursor: 'pointer',
                    }}
                    xs
                    justifyContent={'space-between'}
                >
                    <Grid item xs="auto">
                        {phoneCallerInfo.lineNumber && (
                            <Typography color={'secondary.main'}>
                                {t('customers.label.line')}{' '}
                                {phoneCallerInfo.lineNumber}
                            </Typography>
                        )}
                    </Grid>
                    <Grid item xs container direction={'column'}>
                        <Grid item>
                            <Typography variant="h6">
                                {phoneCallerInfo.callerName}
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography color={'info.main'} fontWeight={'bold'}>
                                {phoneCallerInfo.phoneNumber}
                            </Typography>
                        </Grid>
                        <Grid item>
                            <IOType io={phoneCallerInfo.io} />
                        </Grid>
                    </Grid>
                    <Grid item xs="auto">
                        <Typography color={'secondary.main'}>
                            {phoneCallerInfo.time &&
                                phoneCallerInfo.time.toLocaleTimeString(
                                    'en-US',
                                    {
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        hour12: true,
                                    },
                                )}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid item>
                    <IconButton
                        color="error"
                        onClick={() => setOpenConfirmPopup(true)}
                        sx={{ p: 0 }}
                    >
                        <Delete />
                    </IconButton>
                </Grid>
            </Grid>
            <ConfirmDialog
                open={openConfirmPopup}
                onSave={onRemove}
                onDiscard={() => setOpenConfirmPopup(false)}
                allowClose
                confirmText={t('customers.button.confirm_remove')}
                confirmColor="error"
                title={t('customers.title.confirm_remove')}
            >
                <Trans>
                    {t('customers.message.confirm_remove', {
                        name: phoneCallerInfo.callerName
                            .replaceAll('<', '')
                            .replaceAll('>', ''),
                        phone: phoneCallerInfo.phoneNumber,
                    })}
                </Trans>
            </ConfirmDialog>
        </Box>
    )
}

export default EachPhoneInfo
